/**
 * useMascotMood
 *
 * Derives a MascotEmotion from the active child's lesson-completion progress
 * on their active pathway.  Used to make mascots get visibly happier as the
 * child works through lessons.
 *
 *   0 lessons done  → idle
 *   1–2 lessons done → happy
 *   3+ lessons done  → celebrating
 */

import { useChildStore } from '../store/childStore';
import { resolveActivePathway } from '../utils/activePathway';
import type { MascotEmotion } from '../components/mascots';

export function useMascotMood(): MascotEmotion {
  const { activeChild, progress } = useChildStore();

  const activePathway = resolveActivePathway(activeChild);

  const currentProgress = progress[activePathway.id];
  const completedCount = currentProgress?.lessonsCompleted?.length ?? 0;

  if (completedCount === 0) return 'idle';
  if (completedCount < 3)   return 'happy';
  return 'celebrating';
}
